import * as ActionTypes from '../actions/ActionTypes';
import { RequestStatus } from '../Constants';
import { DefaultVideo2OptInStateMap } from '../types/redux/Video2OptInStatus';
export default function Video2OptInStatus(state = DefaultVideo2OptInStateMap, action) {
  const {
    type,
    videoOptInStatus,
    openModal
  } = action;
  switch (type) {
    case ActionTypes.SET_VIDEO2_OPT_IN_MODAL_OPEN:
      return state.merge({
        openModal
      });
    case ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_ATTEMPTED:
      return state.merge({
        fetchVideo2OptInStatusRequestStatus: RequestStatus.PENDING
      });
    case ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_SUCCEEDED:
      return state.merge({
        fetchVideo2OptInStatusRequestStatus: RequestStatus.SUCCEEDED,
        videoOptInStatus
      });
    case ActionTypes.FETCH_VIDEO2_OPT_IN_STATUS_FAILED:
      return state.merge({
        fetchVideo2OptInStatusRequestStatus: RequestStatus.FAILED
      });
    case ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_ATTEMPTED:
      return state.merge({
        updateVideo2OptInStatusRequestStatus: RequestStatus.PENDING
      });
    case ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_SUCCEEDED:
      return state.merge({
        updateVideo2OptInStatusRequestStatus: RequestStatus.SUCCEEDED,
        videoOptInStatus
      });
    case ActionTypes.UPDATE_VIDEO2_OPT_IN_STATUS_FAILED:
      return state.merge({
        updateVideo2OptInStatusRequestStatus: RequestStatus.FAILED
      });
    default:
      return state;
  }
}